module.exports = __webpack_public_path__ + "img/aed.2476e009.png";